import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/ui-library/assets/logo/horizontal-dark-ava-with-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-91e3230e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo-and-title-container" }
const _hoisted_2 = { class: "logo-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_img, {
        class: "logo",
        src: _imports_0
      })
    ])
  ]))
}